import React from 'react';
import { useAppContext } from '../AppContext';

function BrandLogo() {
  const { uiPath, language, country, variant } = useAppContext();
  const path = `${uiPath}/assets/images/logos`;

  if (country === 'CA') {
    if (language === 'fr') {
      return (
        <img
          alt="Family First"
          src={`${path}/ff-CA-fr-horizontal.png`}
        />
      );
    }

    return (
      <img
        alt="Family First"
        src={`${path}/ff-CA-horizontal.png`}
      />
    );
  }

  return (
    <img
      alt={variant}
      src={`${path}/${variant}.png`}
      style={{ maxHeight: 70 }}
    />
  );
}

export default function GlobalNav() {
  return (
    <div className="global-nav">
      <div className="global-nav__bar">
        <a href="/" className="global-nav__brand stat-logo">
          <BrandLogo />
        </a>
      </div>
    </div>
  );
}
